module.exports = __webpack_public_path__ + "assets/img/my-icon-01.88cd06a2.png";